/*!
 * jQuery lightweight plugin boilerplate
 * Original author: @ajpiano
 * Further changes, comments: @addyosmani
 * Licensed under the MIT license
 */

/*
 * More pluing patterns at:
 * http://coding.smashingmagazine.com/2011/10/11/essential-jquery-plugin-patterns/
*/

(function ($: JQueryStatic) {

    // Create the defaults once
    var pluginName = 'timeMask',
        defaults = {
            propertyName: "value"
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.$el = $(element);

        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;
        this._val = this.$el.val();

        this.init();
    }
    // retruns array of numbers in a string

  
    Plugin.prototype = {
        _getValueInts: function () {
            var ints = [],
                j = 0;

            // Get array of number values    
            for (let i = 0; i < this._val.length; i++) {
                if (parseInt(this._val[i]) >= 0) {
                    ints[j] = parseInt(this._val[i]);
                    j++;
                }
            }
            return ints;
        },

        _isPM: function () {
            return (this._val.search(/p/gi) >= 0);
        },

        _setInvalid: function () {
            this.$el.val("");
        },

        _rmInvalid: function () {
            this.$el.removeClass('invalid-time');
        },


        getTimeStr: function () {
            var n = this._getValueInts(),

                time = [0, 0, 0, 0];                // 00:00

            // No n -> invalid
            if (n.length < 1) {
                return false;
            }

            // Set time array
            else if (n.length == 1) {
                time = [0, n[0], 0, 0];
            }

            else if (n.length == 2) {
                if (n[0] > 1) {                                // "91" => 09:10, 21 => 02:10
                    time = [0, n[0], n[1], 0];
                }
                else if (n[1] >= 6) {                        // "17" => 05:00 pm
                    time = [0, n[1] - 2, 0, 0];
                }
                else {

                    time = [n[0], n[1], 0, 0];       // "12" => 12:00, "05" => 05:00pm
                }
            }

            else if (n.length == 3) {
                if (n[1] >= 6) {                                // "170" => invalid
                    return false;
                }
                else if (n[0] < 1) {                        // "012" => invalid
                    return false;
                }
                else {                                        // "123" => 1:23
                    time = [0, n[0], n[1], n[2]];
                }
            }

            else if (n.length == 4) {
                var hours = n[0] * 10 + n[1];

                if (n[2] >= 6) {                            // 12:95
                    return false;
                }
                else if (hours > 24) {
                    return false;
                }
                else if (hours == 24) {                        // "2312" => 11:12pm; hours = 11
                    hours = 0;

                    time = [0, 0, n[2], n[3]];

                }
                else if (n[0] == 0 && n[1] == 0) {            // "00:12" => 12:12 am
                    time = [0, 0, n[2], n[3]];

                }
                else {

                    time = [n[0], n[1], n[2], n[3]];
                }
            }

            return "" + ((time[0] == 0) ? "0" : time[0]) + time[1] + ":" + time[2] + time[3];
        }, // end getTimeStr()

        _setVal: function (newVal) {
            this.val = newVal;
            this.$el.val(newVal);
        },


        init: function () {
            var _this = this;
            this.$el.bind({
                'focus.timeMask': function () {
                    _this._rmInvalid();
                },
                'change.timeMask': function () {
                    _this._val = _this.$el.val();
                    var timeStr = _this.getTimeStr();

                    if (!timeStr) {
                        _this._setInvalid();
                    }
                    else {
                        _this._setVal(timeStr);
                    }
                }
            }); // end this$el.bind
        } // end init

        /* // This would be nice, but this plugin pattern isn't set up for public methods... 
        destroy: function() {
        console.log('destroying');
        this.$el.unbind('.timeMask');
        }*/

    }; // end Plugin.prototype
    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin(this, options));
            }
        });
    };

})(jQuery);


// WEBPACK FOOTER //
// ./ScriptsTS/TimeMask.ts